import { useMemo } from 'react';
import { Container, FilterButton } from './styled';
import CloseIcon from '~/icons/iconography/close.svg';
import { useTranslations } from '~/services/umbraco/hooks';
import { theme } from '~/theme';
import { DropdownItem } from '../DropdownSelector/models';

type Props = {
    filterElementList?: DropdownItem[];
    setSelectedStatus: (selected: DropdownItem[]) => void;
};

export function CurrentFilters({ filterElementList, setSelectedStatus }: Props) {
    const { translate } = useTranslations();

    const removeSearchFilter = (filterName: string) => {
        const newFilterList = filterElementList?.filter((filter) => filter.value !== filterName);

        if (newFilterList) {
            setSelectedStatus(newFilterList);
        }
    };

    const filterElement = useMemo(
        () =>
            !filterElementList ? null : (
                <>
                    {filterElementList.map((filter) => (
                        <li key={filter.value}>
                            <FilterButton
                                color={theme.colors.nightBlack}
                                noIcon
                                onClick={() => {
                                    removeSearchFilter(filter.value);
                                }}
                                type="button"
                                variant="stroke"
                            >
                                <CloseIcon />
                                {filter.label}
                            </FilterButton>
                        </li>
                    ))}
                </>
            ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [filterElementList],
    );

    return (filterElementList?.length || 0) < 1 ? null : (
        <Container>
            <li>
                <FilterButton
                    removeAllElementFilter
                    color={theme.colors.nightBlack}
                    noIcon
                    onClick={() => {
                        setSelectedStatus([]);
                    }}
                    type="button"
                >
                    <CloseIcon />
                    {translate('product-list.reset')}
                </FilterButton>
            </li>

            {filterElement}
        </Container>
    );
}
